// extracted by mini-css-extract-plugin
module.exports = {"mobileDropdown":"Period_mobileDropdown__ShVYw"};